import { userInitials } from './shared/userInitials';
import SpringAnnouncement from './shared/SpringAnnouncement';
import MenuSearchResults from './shared/MenuSearchResults';
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Grid, Typography, InputBase, IconButton, Skeleton } from '@mui/material';
import { Search, Close } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { usePermisos } from '../hooks/usePermisos';
import { useModoReducido } from '../hooks/useModoReducido';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip as CT, Filler } from 'chart.js';
import { HeaderIOS, SeccionApps, TarjetaApp, InfoCard, IOS } from './shared/MenuLayout';


ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, CT, Filler);


const MODS = {
  1:{id:'admision',nombre:'Admisión',ruta:'/admision', orden:1 },
  2:{id:'emergencia',nombre:'Emergencia',ruta:'/emergencia', orden:2 },
  3:{id:'caja',nombre:'Caja',ruta:'/caja', orden:4 },
  4:{id:'consultorios',nombre:'Consultorios',ruta:'/consultorios', orden:5 },
  5:{id:'economia',nombre:'Economía',ruta:'/economia', orden:6 },
  6:{id:'ecografia',nombre:'Ecografías',ruta:'/ecografia', orden:7 },
  7:{id:'farmacia',nombre:'Farmacia',ruta:'/farmacia', orden:8 },
  55:{id:'datafarma', nombre:'DataFarma', ruta:'/datafarma', orden:9 },
  8:{id:'hospitalizacion',nombre:'Hospitalización',ruta:'/hospitalizacion', orden:10 },
  9:{id:'laboratorio',nombre:'Laboratorio',ruta:'/laboratorio', orden:11 },
  10:{id:'rayosx',nombre:'Rayos X',ruta:'/rayosx', orden:12 },
  11:{id:'seguros',nombre:'Seguros',ruta:'/seguros', orden:13 },
  12:{id:'usuarios',nombre:'Usuarios',ruta:'/usuarios', orden:14 },
  34:{id:'roles',nombre:'Roles',ruta:'/roles', orden:15 },
  
  

};
const RUTAS={ventas:'/farmacia/ventas',anulaciones:'/farmacia/anulaciones',kardex:'/farmacia/kardex',inventario:'/farmacia/inventario',ajustes:'/farmacia/ajustes',stock:'/farmacia/stock',almacen:'/farmacia/almacen',productos:'/farmacia/productos',reporte:'/farmacia/reporte-ventas',indicadores:'/farmacia/indicadores',consumos:'/farmacia/consumo',consumopac:'/farmacia/consumo-paciente',requerimiento:'/farmacia/requerimiento',narcoticos:'/farmacia/libro-narcoticos',psicotropicos:'/farmacia/libro-psicotropicos',conteo:'/farmacia/reporte-conteo',devoluciones:'/farmacia/devoluciones-dosis',comprobantes:'/economia/comprobantes-pago','libro-ventas':'/economia/libro-ventas','consulta-cpe':'/economia/consulta-cpe','monitor-envios':'/economia/monitor-envios'};
const NOMBRES={ventas:'Ventas',anulaciones:'Anulaciones',kardex:'Kardex',inventario:'Inventario',ajustes:'Ajustes',stock:'Stock',almacen:'Almacén',productos:'Productos',reporte:'Rep. Ventas',indicadores:'Indicadores',consumos:'Consumos',consumopac:'Consumo Pac.',requerimiento:'Requerimiento',narcoticos:'Narcóticos',psicotropicos:'Psicotrópicos',conteo:'Rep. Conteo',devoluciones:'Devolución','comprobantes':'Comprobantes','libro-ventas':'Libro Ventas','consulta-cpe':'Consulta CPE','monitor-envios':'Monitor Envíos'};

const NOMBRES_MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const DIAS_SEMANA = ['D','L','M','M','J','V','S'];
const TIPO_COLOR = {
  'cumpleaños':        IOS.red,
  'feriado':           IOS.orange,
  'feriado nacional':  IOS.orange,
  'dia profesional':   IOS.green,
  'día profesional':   IOS.green,
};

const Globos = () => {
  const piezas = useMemo(() => Array.from({length:80},(_,i)=>({
    id:i,
    left: Math.random()*100,
    delay: Math.random()*3,
    duration: 2.5+Math.random()*3,
    size: 5+Math.random()*8,
    color: ['#FF2D55','#007AFF','#34C759','#FF9500','#5E5CE6','#5AC8FA','#FFD60A'][Math.floor(Math.random()*7)],
    forma: Math.random()>0.5?'50%':'2px',
    rotate: Math.random()*360,
  })),[]);

  return (
    <Box sx={{position:'fixed',inset:0,zIndex:99999,pointerEvents:'none',overflow:'hidden'}}>
      <style>{`
        @keyframes confettiFall {
          0%   { transform: translateY(-20px) rotate(0deg) scale(1); opacity:1; }
          80%  { opacity:1; }
          100% { transform: translateY(105vh) rotate(720deg) scale(0.8); opacity:0; }
        }
      `}</style>

      {piezas.map(p=>(
        <Box key={p.id} sx={{
          position:'absolute',
          top: -20,
          left:`${p.left}%`,
          width: p.size,
          height: p.size * (Math.random()>0.5?1:0.4),
          bgcolor: p.color,
          borderRadius: p.forma,
          animation:`confettiFall ${p.duration}s ${p.delay}s ease-in forwards`,
        }}/>
      ))}

      {/* Globos */}
      {Array.from({length:12},(_,i)=>({
        id:i,
        left: 5+Math.random()*90,
        delay: Math.random()*2,
        duration: 3+Math.random()*3,
        color: ['#FF2D55','#007AFF','#34C759','#FF9500','#5E5CE6','#FFD60A'][i%6],
      })).map(g=>(
        <Box key={`g${g.id}`} sx={{
          position:'absolute',
          bottom:-80,
          left:`${g.left}%`,
          animation:`subirGlobo ${g.duration}s ${g.delay}s ease-in forwards`,
        }}>
          <style>{`
            @keyframes subirGlobo {
              0%   { transform: translateY(0) rotate(-5deg); opacity:1; }
              100% { transform: translateY(-115vh) rotate(5deg); opacity:0; }
            }
          `}</style>
          <svg width="28" height="36" viewBox="0 0 28 36" fill={g.color}>
            <ellipse cx="14" cy="14" rx="13" ry="14"/>
            <path d="M14 28 Q12 31 14 34 Q16 31 14 28" fill={g.color} opacity="0.8"/>
            <ellipse cx="9" cy="9" rx="4" ry="3" fill="rgba(255,255,255,0.25)"/>
          </svg>
        </Box>
      ))}

      {/* Card central */}
      <Box sx={{
        position:'fixed',
        top:'42%',left:'50%',
        transform:'translate(-50%,-50%)',
        textAlign:'center',
        px:5,py:4,
        borderRadius:'28px',
        background:'linear-gradient(135deg, #FF2D55 0%, #FF6B35 50%, #FF9500 100%)',
        boxShadow:'0 20px 60px rgba(255,45,85,0.45), 0 8px 24px rgba(0,0,0,0.2)',
        minWidth:280,
        animation:'fadeInCard 0.4s ease',
      }}>
        <style>{`
          @keyframes fadeInCard {
            from { transform:translate(-50%,-50%) scale(0.8); opacity:0; }
            to   { transform:translate(-50%,-50%) scale(1);   opacity:1; }
          }
        `}</style>
        <Box sx={{mb:1.5}}>
          {/* Icono pastel */}
          <Box sx={{width:70,height:70,borderRadius:'50%',bgcolor:'rgba(255,255,255,0.2)',
            display:'flex',alignItems:'center',justifyContent:'center',mx:'auto',mb:1.5}}>
            <img src="/Imagenes/VIC_LOGO.png" alt="logo"
              style={{width:50,height:50,objectFit:'contain',filter:'brightness(0) invert(1)'}}/>
          </Box>
          <Typography sx={{fontSize:'1.6rem',fontWeight:900,color:'white',lineHeight:1.1,letterSpacing:'-0.02em',
            textShadow:'0 2px 8px rgba(0,0,0,0.15)'}}>
            ¡Feliz Cumpleaños!
          </Typography>
        </Box>
        <Typography sx={{fontSize:'0.95rem',color:'rgba(255,255,255,0.9)',fontWeight:500,lineHeight:1.5}}>
          El equipo de ardata te desea un día increíble
        </Typography>
        <Box sx={{mt:2,display:'flex',justifyContent:'center',gap:1}}>
          {['#fff','rgba(255,255,255,0.6)','#fff'].map((c,i)=>(
            <Box key={i} sx={{width:6,height:6,borderRadius:'50%',bgcolor:c}}/>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const EventosMes = ({ eventos }) => {
  const hoy = new Date();
  const mesActual = hoy.getMonth();
  const anhoActual = hoy.getFullYear();
  const NOMBRES_MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

  const getColor = (tipo) => {
    const t = (tipo||'').toLowerCase();
    if(t.includes('cumple')) return '#FF2D55';
    if(t.includes('feriado')) return '#FF9500';
    if(t.includes('profesional')||t.includes('festivo')) return '#00B76C';
    return '#AF52DE';
  };

  const getIcon = (tipo, color) => {
    const t = (tipo||'').toLowerCase();
    if(t.includes('cumple')) return (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13m0-13H8.5A2.5 2.5 0 1 1 11 5.5L12 8Zm0 0h3.5A2.5 2.5 0 1 0 13 5.5L12 8Z"/>
      </svg>
    );
    if(t.includes('feriado')) return (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5"/>
      </svg>
    );
    return (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    );
  };

  const eventosMes = useMemo(() => {
    return eventos
      .filter(e => {
        if(!e.fecha) return false;
        const [y,m] = e.fecha.split('-').map(Number);
        return y===anhoActual && m-1===mesActual;
      })
      .sort((a,b) => a.fecha.localeCompare(b.fecha));
  }, [eventos, mesActual, anhoActual]);

  const esHoy = (fecha) => {
    const h = `${anhoActual}-${String(mesActual+1).padStart(2,'0')}-${String(hoy.getDate()).padStart(2,'0')}`;
    return fecha === h;
  };

  const fmtDia = (fecha) => {
    const [,,d] = fecha.split('-').map(Number);
    return String(d).padStart(2,'0');
  };

  const tiposUnicos = [...new Set(eventosMes.map(e=>(e.tipo||'').toLowerCase()))];

  return (
    <Box className="dashboard-agenda" sx={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif', '& .MuiTypography-root': { fontFamily: 'inherit' }, bgcolor: '#FFFFFF', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 8px 28px rgba(20,28,45,0.065)', border: '1px solid #E7EBF0', mt: 1.8, '@media (prefers-reduced-motion: reduce)': { '& *': { transition: 'none' } } }}>
      
      {/* Cabecera de la agenda */}
      <Box sx={{ px: 2, pt: 2, pb: 1.2, height: 74.25, boxSizing: 'border-box', position: 'relative', borderBottom: '1px solid transparent', background: '#FFFFFF' }}>
        <Box aria-hidden="true" sx={{ position: 'absolute', right: 16, top: 20, width: 34, height: 34, borderRadius: '12px', bgcolor: '#F5F5F7', color: '#1C1C1E', display: 'grid', placeItems: 'center' }}>
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="5" width="16" height="16" rx="4"/><path d="M8 3v4m8-4v4M4 11h16m-12 4h2m4 0h2m-8 3h2"/>
          </svg>
        </Box>
        <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#6E6E73', letterSpacing: '0.07em', textTransform: 'uppercase', mb: 0.5 }}>
          PRÓXIMOS EVENTOS
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.8 }}>
          <Typography sx={{ fontWeight: 700, fontSize: '1.375rem', lineHeight: '26.4px', letterSpacing: '-0.045em', color: '#171A21' }}>
            {NOMBRES_MESES[mesActual]}
          </Typography>
          <Typography sx={{ fontSize: '0.8rem', fontWeight: 500, color: '#626B7A' }}>
            {anhoActual}
          </Typography>
          {eventosMes.length > 0 && (
            <Box sx={{ bgcolor: '#F2F2F7', borderRadius: '14px', px: 0.8, py: 0.2, ml: 0.5 }}>
              <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#636366' }}>
                {eventosMes.length}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* Lista de eventos con mejor espaciado */}
      {eventosMes.length === 0 ? (
        <Box sx={{ py: 5, textAlign: 'center' }}>
          <Box sx={{ width: 40, height: 40, borderRadius: '14px', bgcolor: '#F0F4F8', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 1 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#626B7A" strokeWidth="1.5">
              <rect x="3" y="4" width="18" height="18" rx="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
          </Box>
          <Typography sx={{ fontSize: '0.75rem', color: '#626B7A', fontWeight: 500 }}>No hay eventos este mes</Typography>
        </Box>
      ) : (
        <Box className="dashboard-agenda-list" sx={{ px: 1.5, py: 1.5, display: 'flex', flexDirection: 'column', gap: 1.2, maxHeight: 210, overflowY: 'auto', '&::-webkit-scrollbar': { width: 4 }, '&::-webkit-scrollbar-thumb': { bgcolor: '#D5DDE7', borderRadius: 4 } }}>
          {eventosMes.map((e, i) => {
            const color = getColor(e.tipo);
            const icon = getIcon(e.tipo, color);
            const hoyFlag = esHoy(e.fecha);
            return (
              <Box
                key={i}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.2,
                  p: 1,
                  borderRadius: '12px', position: 'relative',
                  bgcolor: 'transparent', '&:not(:last-child)::after': { content: '""', position: 'absolute', left: 62, right: 8, bottom: -5, height: '1px', bgcolor: '#F0F0F3' },
                  transition: 'background 0.2s',
                  '&:hover': { bgcolor: '#F8F8FA' },
                }}
              >
                {/* Fecha destacada */}
                <Box sx={{ textAlign: 'center', flexShrink: 0, width: 44, alignSelf: 'stretch', display: 'flex', flexDirection: 'column', justifyContent: 'center', fontVariantNumeric: 'tabular-nums' }}>
                  <Typography sx={{ fontSize: '1.7rem', fontWeight: 600, letterSpacing: '-0.06em', color, lineHeight: '21.109375px' }}>
                    {fmtDia(e.fecha)}
                  </Typography>
                  <Typography sx={{ fontSize: '0.62rem', lineHeight: '17.265625px', fontWeight: 600, letterSpacing: '0.04em', color: '#8E8E93', textTransform: 'uppercase', order: -1, mb: 0.2 }}>
                    {(()=>{ const [y,m,d]=e.fecha.split('-').map(Number); return new Date(y,m-1,d).toLocaleDateString('es-ES',{weekday:'short'}).replace('.',''); })()}
                  </Typography>
                </Box>

                {/* Información */}
                <Box sx={{ flex: 1, minWidth: 0, pl: 1.3, position: 'relative', '&::before': { content: '""', position: 'absolute', left: 0, top: 1, bottom: 1, width: 3, borderRadius: '3px', bgcolor: color } }}>
                  <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, letterSpacing: '-0.015em', color: '#171A21', lineHeight: 1.3, mb: 0.3 }}>
                    {e.ben}
                  </Typography>
                  {e.nombre && <Typography sx={{fontSize:12,lineHeight:1.4,color:"#65748B",mb:.6,overflowWrap:"anywhere"}}>{e.nombre}</Typography>}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    {icon}
                    <Typography sx={{ fontSize: '0.72rem', fontWeight: 400, color: '#6E6E73', textTransform: 'capitalize' }}>
                      {e.tipo}
                    </Typography>
                  </Box>
                </Box>

                {/* Badge HOY */}
                {hoyFlag && (
                  <Box sx={{ bgcolor: '#FF3B30', borderRadius: '7px', px: 0.9, py: 0.4, flexShrink: 0 }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#FFFFFF', letterSpacing: 0.3 }}>
                      HOY
                    </Typography>
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      )}

      {/* Leyenda opcional, más suave */}
      {tiposUnicos.length > 0 && (
        <Box sx={{ px: 2, py: 1.2, borderTop: '1px solid #EEF1F4', bgcolor: '#FFFFFF', display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
          {tiposUnicos.map(tipo => (
            <Box key={tipo} sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
              <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: getColor(tipo) }} />
              <Typography sx={{ fontSize: '0.72rem', fontWeight: 500, color: '#626B7A', textTransform: 'capitalize' }}>
                {tipo}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};
const DashboardInicio = () => {
  const navigate = useNavigate();
  const { permisos, cargando, tieneModulo } = usePermisos();
  const { reducido, moduloPermitido, opcionFarmaciaPermitida, opcionEconomiaPermitida, cargando: cargandoModo } = useModoReducido();
  const user = authService.getCurrentUser();
  const nc = user?.nombreCompleto || user?.usuario || '';
  const cap = t => t.toLowerCase().split(' ').map(p=>p.charAt(0).toUpperCase()+p.slice(1)).join(' ');
  const nf = cap(nc);
  const rol=user?.rol||'', priv=user?.privilegio||'', perm=user?.permisos||0;
  const ipress=user?.ipress||'', ipressD=user?.ipressDescripcion||'';
  const lat=parseFloat(user?.latitud)||0, lng=parseFloat(user?.longitud)||0;
  const hora=new Date().getHours();
  const saludo=hora<12?'Buenos días':hora<18?'Buenas tardes':'Buenas noches';

const [ses,setSes]=useState([]);
const [mesesGraf,setMesesGraf]=useState([]);
const [cgraf,setCgraf]=useState(true);
const [hov,setHov]=useState(null);
const [busqueda,setBusqueda]=useState('');
const normalizar = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
const coincide = text => normalizar(text).includes(normalizar(busqueda.trim()));

const [eventos, setEventos] = useState([]);
const [mesActual, setMesActual] = useState(new Date().getMonth());
const [anhoActual, setAnhoActual] = useState(new Date().getFullYear());
const [diaSeleccionado, setDiaSeleccionado] = useState(null);
const [mostrarGlobos, setMostrarGlobos] = useState(false);
  const ueId = user?.ueIdEstablecimiento||user?.UeIdEstablecimiento||0;
  const userId = user?.idUser||0;


  useEffect(() => {
    api.get(`/dashboard/grafico-accesos?usuario=${user?.usuario}`)
    .then(r=>{if(r.data.success){setSes(r.data.cantidades);setMesesGraf(r.data.meses);}})
    .catch(console.error).finally(()=>setCgraf(false));

  api.get(`/dashboard/eventos-calendario?idUe=${ueId}`)
    .then(r => {
      if (r.data.success) {
        const eventos = r.data.data || [];
        const ahora = new Date();
        const hoy = `${ahora.getFullYear()}-${String(ahora.getMonth() + 1).padStart(2, '0')}-${String(ahora.getDate()).padStart(2, '0')}`;
        const esMiCumple = eventos.some(e =>
          e.tipo?.toLowerCase() === 'cumpleaños' &&
          e.fecha === hoy &&
          String(e.userId) === String(userId)
        );
        setEventos(eventos);
        if (esMiCumple) {
          setMostrarGlobos(true);
          setTimeout(() => setMostrarGlobos(false), 5000);
        }
      }
    }).catch(console.error);
}, [user?.usuario]);

  const logout=()=>{authService.logout();navigate('/login');};
  const tieneM=!cargando&&permisos?.modulos?.length>0;
  const tieneSueltas=!cargando&&!tieneM&&permisos?.opciones?.length>0;

  const agrupadas=React.useMemo(()=>{
    if(!tieneSueltas)return[];
    const g={};
    permisos.opciones.forEach(o=>{if(!g[o.moduloId])g[o.moduloId]=[];g[o.moduloId].push(o.permiso);});
    return Object.entries(g).map(([id,ops])=>({mid:parseInt(id),mod:MODS[parseInt(id)],ops}));
  },[tieneSueltas,permisos]);

  const cd={labels:mesesGraf,datasets:[{data:ses,borderColor:IOS.purple,backgroundColor:`${IOS.purple}15`,borderWidth:2,fill:true,tension:0.4,pointRadius:4,pointHoverRadius:5,pointBackgroundColor:IOS.purple,pointBorderColor:'#fff',pointBorderWidth:1.5}]};
  const co = {
    responsive: true, maintainAspectRatio: false,
    animation: { duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600, easing: 'easeInOutQuart' },
    plugins: {
        datalabels: { display: false },
      legend: { display: false },
      tooltip: { backgroundColor: '#222B45', padding: 12, borderRadius: 12, displayColors: false },
    },
    animations: {
      x: { duration: 0 },
      y: { duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600, easing: 'easeInOutQuart', delay: (ctx) => ctx.dataIndex * 80 },
      radius: { duration: 400, easing: 'easeInOutQuart', delay: (ctx) => ctx.dataIndex * 80 },
    },
    scales: {
      y: { beginAtZero:true, ticks:{precision:0,maxTicksLimit:4,color:IOS.label2,font:{size:10}}, border:{display:false},grid:{color:'rgba(60,60,67,.06)'} },
      x: { grid: { display: false }, border: { display: false },
        ticks: { color: IOS.label2, font: { size: 10 } } }
    }
  };

  return (
  <Box className="integra-menu" sx={{minHeight:'100vh',bgcolor:IOS.bg}}>
    <SpringAnnouncement />
    {mostrarGlobos&&<Globos/>}
    <HeaderIOS onLogout={logout}nombreCompleto={nf} avatarLetra={userInitials(user, nc)}/>
      <Box sx={{maxWidth:1400,mx:'auto',px:{xs:2,sm:4},pt:3.5,pb:6}}>

        <Grid container spacing={2.5} className="integra-launcher-layout">
          <Grid item xs={12} lg={8}>
        <Box sx={{mb:4}}>
          <Typography sx={{fontSize:'.7rem',fontWeight:700,color:IOS.label2,letterSpacing:'.12em',textTransform:'uppercase',mb:1.5}}>Tu espacio de trabajo</Typography>
          <Typography component="h1" sx={{fontSize:{xs:'2rem',sm:'2.65rem'},fontWeight:700,color:IOS.label,lineHeight:1.15,letterSpacing:'-0.025em'}}>{saludo},</Typography>
          <Typography sx={{fontSize:{xs:'2rem',sm:'2.65rem'},fontWeight:700,color:IOS.purple,lineHeight:1.15,letterSpacing:'-0.025em'}}>{nf.split(' ')[0]}.</Typography>
          <Typography sx={{mt:1.5,color:IOS.label2,fontSize:'.9rem'}}>Todo lo que necesitas para empezar tu jornada.</Typography>
        </Box>

        {reducido && (
          <Box sx={{ mb:3, p:1.8, borderRadius:'14px', bgcolor:'#FFF8E6', border:'1px solid #FFE9A0',
            display:'flex', alignItems:'flex-start', gap:1.2 }}>
            <Box sx={{ width:26, height:26, borderRadius:'8px', bgcolor:'#FFE9A0', flexShrink:0,
              display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8B6914" strokeWidth="2" strokeLinecap="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </Box>
            <Typography sx={{ fontSize:'0.78rem', color:'#8B6914', fontWeight:600 }}>
              Sistema en modo reducido — solo Farmacia (Productos y Reporte de Conteo) está disponible mientras se regulariza el pago.
            </Typography>
          </Box>
        )}


            <Box sx={{display:'flex',alignItems:'center',gap:1.2,bgcolor:'rgba(255,255,255,.85)',border:'1px solid #DCE2EE',borderRadius:'16px',px:2,mb:3,minHeight:50,'&:focus-within':{borderColor:IOS.blue,boxShadow:'0 0 0 3px #007AFF12'}}}>
              <Search sx={{fontSize:21,color:IOS.label2}}/>
              <InputBase fullWidth value={busqueda} onChange={e=>setBusqueda(e.target.value)} onKeyDown={e=>{if(e.key==='Escape')setBusqueda('');}} placeholder="¿Qué necesitas hacer? Stock, ventas, recetas…" inputProps={{'aria-label':'Buscar opciones por nombre o función',maxLength:120}} sx={{fontSize:'.88rem'}}/>
              {busqueda && <IconButton aria-label="Limpiar búsqueda" onClick={()=>setBusqueda('')} sx={{minWidth:44,minHeight:44}}><Close fontSize="small"/></IconButton>}
            </Box>
            {busqueda.trim() ? <MenuSearchResults query={busqueda} permisos={permisos} loading={cargando || cargandoModo} restrictions={{moduloPermitido,opcionFarmaciaPermitida,opcionEconomiaPermitida}}/> : <>
            {tieneM && (
                <Grid container spacing={1.5}>
                  {Object.values(MODS).filter(m=>coincide(m.nombre)).sort((a,b)=>a.orden - b.orden) .map(m=>(
                    <Grid item xs={4} sm={2} key={m.id}>
                      <TarjetaApp id={m.id} nombre={m.nombre} iconKey={m.id} ruta={m.ruta}
                        bloqueado={!tieneModulo(m.id) || !moduloPermitido(m.id)} hoveredId={hov} onHover={setHov} onLeave={()=>setHov(null)}/>
                    </Grid>
                  ))}
                </Grid>
            )}

            {tieneSueltas && agrupadas.filter(g=>g.ops.some(p=>coincide(NOMBRES[p]||p))).map(({mid,mod,ops})=>(
              <SeccionApps key={mid} label={mod?.nombre||`Módulo ${mid}`} color={IOS.purple}>
                <Grid container spacing={1.5}>
                  {ops.filter(p=>coincide(NOMBRES[p]||p)).map(p=>(
                    <Grid item xs={4} sm={2} key={p}>
                      <TarjetaApp id={`${mid}-${p}`} nombre={NOMBRES[p]||p} iconKey={p}
                        ruta={RUTAS[p]||'#'} bloqueado={!moduloPermitido(mod?.id)} hoveredId={hov} onHover={setHov} onLeave={()=>setHov(null)}/>
                    </Grid>
                  ))}
                </Grid>
              </SeccionApps>
            ))}

            {!cargando && !tieneM && !tieneSueltas && <Typography sx={{p:3,color:IOS.label2}}>No tienes módulos asignados. Consulta con el administrador.</Typography>}
            {cargando && <Box sx={{py:8,textAlign:'center'}}><Typography sx={{color:IOS.label2,fontSize:'0.88rem'}}>Cargando...</Typography></Box>}
            </>}

          </Grid>

          <Grid item xs={12} lg={4} className="integra-launcher-cards dashboard-widgets" component="aside" aria-label="Resumen de tu espacio">
            <InfoCard>
              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em',textTransform:'uppercase',mb:0.3}}>Sesiones totales</Typography>
              <Typography sx={{fontSize:'2rem',fontWeight:700,color:IOS.label,letterSpacing:'-0.03em',lineHeight:1,mb:1.5}}>
                {cgraf ? '—' : ses.length ? ses.reduce((a,b)=>a+Number(b),0).toLocaleString('es-PE') : '—'}
              </Typography>
              <Box className="dashboard-sessions-chart" sx={{height:150}}>
                {cgraf ? <Skeleton variant="rounded" height={140}/> : ses.length>0?<Line role="img" aria-label="Sesiones por mes" data={cd} options={co}/>
                  :<Box sx={{height:'100%',display:'flex',alignItems:'center',justifyContent:'center'}}><Typography sx={{color:IOS.label3,fontSize:'0.78rem'}}>Sin datos</Typography></Box>}
              </Box>
            </InfoCard>

            <InfoCard color={IOS.purple}>
  <Box sx={{display:'flex',alignItems:'center',gap:1.5,mb:2}}>
    <Box sx={{width:40,height:40,borderRadius:'50%',bgcolor:'rgba(255,255,255,0.2)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
      <Typography sx={{fontSize:'1.1rem',fontWeight:700,color:'white'}}>{userInitials(user, nc)}</Typography>
    </Box>
    <Box sx={{minWidth:0}}>
      <Typography sx={{color:'white',fontWeight:700,fontSize:'0.9rem',lineHeight:1.2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{nf}</Typography>
      <Typography sx={{color:'rgba(255,255,255,0.65)',fontSize:'0.7rem'}}>{rol}</Typography>
    </Box>
  </Box>
  <Box sx={{display:'grid',gridTemplateColumns:'repeat(2,minmax(0,1fr))',gap:1,mb:1.5}}>
    {[['Privilegio',priv],['Permisos',perm],['Establecimiento',ipress]].map(([l,v])=>(
      <Box key={l} sx={{gridColumn:l==='Establecimiento'?'1 / -1':'auto',bgcolor:'rgba(255,255,255,0.15)',borderRadius:'10px',p:1.2}}>
        <Typography sx={{color:'rgba(255,255,255,0.6)',fontSize: '0.72rem',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.3}}>{l}</Typography>
        <Typography sx={{color:'white',fontWeight:700,fontSize:'0.92rem'}}>{v}</Typography>
      </Box>
    ))}
  </Box>

</InfoCard>
            <EventosMes eventos={eventos} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
export default DashboardInicio;
